import { render, staticRenderFns } from "./BillIcon2.vue?vue&type=template&id=1baeee54&"
import script from "./BillIcon2.vue?vue&type=script&lang=ts&"
export * from "./BillIcon2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports